// extracted by mini-css-extract-plugin
export default {"TeaserCardComponent":"TeaserCardComponent_jXTi2"};